import { useEffect } from 'react';

/** Width (px) of the edge strips where a swipe can trigger browser back/forward. */
const EDGE = 30;
/** Header zone (px) left alone so hamburger taps aren't blocked. */
const HEADER = 80;
/**
 * Controls whose tap must survive: cancelling a touchstart also cancels the
 * tap's click, so a button in the edge strip (the composer reply chip's gear)
 * would be dead.
 */
const INTERACTIVE = 'button, a[href], input, select, textarea, label, [role="button"], [contenteditable="true"]';

interface EdgeTouch {
	x: number;
	y: number;
	viewportWidth: number;
	target: EventTarget | null;
}

/** True when a touchstart should be cancelled to stop an edge-swipe navigation. */
export const shouldBlockEdgeTouch = ({ x, y, viewportWidth, target }: EdgeTouch): boolean => {
	const isEdge = x < EDGE || x > viewportWidth - EDGE;
	if (!isEdge || y <= HEADER) return false;
	return !(target instanceof Element && target.closest(INTERACTIVE));
};

/** Prevents browser back/forward navigation triggered by edge swipes on mobile. */
export function useDisableSwipeNav() {
	useEffect(() => {
		const handler = (e: TouchEvent) => {
			const touch = e.touches[0];
			if (shouldBlockEdgeTouch({ x: touch.pageX, y: touch.pageY, viewportWidth: window.innerWidth, target: e.target })) {
				e.preventDefault();
			}
		};

		document.addEventListener('touchstart', handler, { passive: false });
		return () => document.removeEventListener('touchstart', handler);
	}, []);
}
